module.exports = __webpack_public_path__ + "img/white_paper14.65732917.png";